import type { IconData } from '@stacksjs/iconify-core'

export const accountLogout: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M77.155 272.034H351.75v-32.001H77.155l75.053-75.053v-.001l-22.628-22.626l-113.681 113.68l.001.001h-.001L129.58 369.715l22.628-22.627v-.001z\"/><path fill=\"currentColor\" d=\"M160 16v32h304v416H160v32h336V16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default accountLogout
